import { EVENT_NAMES, useAnalytics } from '@web-app/context/AnalyticsContext';
import { useOrganizationConfig } from '@web-app/hooks/whitelabel/useOrganizationConfig';
import { buildRedirectUrlWithTracking } from '@web-app/utils/url-builder';
import { useCallback } from 'react';

/**
 * Hook that provides a function to redirect patients to the patient app.
 * Handles organization-specific redirect URLs and analytics tracking.
 */
export const useRedirectToPatientApp = () => {
  const config = useOrganizationConfig();
  const { trackEvent } = useAnalytics();

  const redirect = useCallback(() => {
    const redirectUrl =
      config?.app.patientRedirectUrl ||
      process.env.NEXT_PUBLIC_PATIENT_REDIRECT_URL;

    if (redirectUrl) {
      trackEvent(EVENT_NAMES.CLICKS_LEAVE_CALL_REDIRECT);
      window.location.href = buildRedirectUrlWithTracking(redirectUrl);
    }
  }, [config?.app.patientRedirectUrl, trackEvent]);

  return redirect;
};
